import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class CatalogManagementClient {
  static baseUrl = BASE_URL;

  static saveNewCatalogClient(user, request) {
    const url = `${this.baseUrl}/catalogEnablement?catalogId=${request.catalogId}&model=${request.model}&modelYear=${request.modelYear}&market=${request.market}&vehicleType=${request.vehicleType}&isModelE=${request.isModelE}&enableAccessories=${request.enableAccessories}&factNumber=${request.factNumber}&user=${request.user}`;

    return axios
      .post(url, null, getHeaders(user.token))
      .then((response) => response)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}
